import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { OverlayHandler } from '@core/handler/overlay.handler';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { ButtonSecondaryComponent } from '@shared/ui/buttons/button-secondary/button-secondary.component';

@Component({
  selector: 'crm-overlay-dialog',
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatDialogClose,
    TranslatePipe,
    MatIcon,
    ButtonSecondaryComponent,
  ],
  templateUrl: './overlay-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './overlay-dialog.component.scss',
})
export class OverlayDialog {
  protected readonly overlayHandler = inject(OverlayHandler);
}
